import { Injectable } from '@angular/core';
import { ShareCartPayload } from '@cart/const';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CartActions } from '../store/actions';
import { StateWithCustomCart } from '../store/cart-state';
import { ShareCartSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class ShareCartFacade {
  constructor(protected store: Store<StateWithCustomCart>) {}

  shareCart(): void {
    this.store.dispatch(new CartActions.ShareCart());
  }

  getShareCartValue(): Observable<ShareCartPayload> {
    return this.store.pipe(select(ShareCartSelectors.getShareCartValue));
  }

  resetShareCartValue(): void {
    this.store.dispatch(new CartActions.ShareCartReset());
  }
}
